/**
 * ✉ 메일 — 받은 메일 보기 · 쓰기 · 답장 · 전달 (v2.205.0 · 2026-09-24)
 *
 * 사용자 요청(개발 계획 「메일」 글): 「문서 결재 쪽에 메일 메뉴를 만들어서 받은메일도 확인할 수 있고 작성도 할 수
 * 있도록 · 메일 작성시 첨부파일은 포털의 보관 중인 문서를 바로 첨부 · TSP 에 같은 기능이 있는데 이런 UI 형태로」
 * → 사용자 결정(첫 판 범위): **읽기 + 쓰기 + 답장·전달** (검색·NAS 저장은 다음 판).
 *
 * 화면: 왼쪽 메일함 · 가운데 목록 · 오른쪽 읽기 (TSP 캡처와 같은 3단).
 *   · 쓰기·답장·전달은 **포털 공용 메일 창**(MailComposeModal)을 그대로 연다 — [+ 포털 보관 문서] 첨부가 이미 있다.
 *   · 본문은 서버 정리 → 화면 정리 → 격리 틀(sandbox iframe) 3중 방어로만 그린다(lib/mail-render.ts).
 * ⭐메일은 우리 DB 에 두지 않는다 — 열 때마다 웍스에서 받는다(각자 연결한 본인 메일함).
 *
 * 🔍 v2.206.0 (2026-09-26 · 사용자 요청 「TSP 캡처 참고해서 보완해줘. 검색기능 등」 · 결정 「둘 다」·「기본 전체 메일함」)
 *   · 검색 두 가지 — [내용] 웍스 공식 검색(제목·본문·첨부 · 전체 메일함 기본 · 최근 1년 → 5년) /
 *     [보낸 사람] 지금 메일함을 1,000건씩 훑음(보낸메일함은 받는 사람). 훑은 범위를 **늘 보여 준다**.
 *   · 찾은 글자 강조는 서버가 준 **글자 조각**으로만 그린다(<Highlight> — HTML 로 안 그린다).
 *   · 좁은 화면(폰·접는 폰): 목록이 화면 가득 → 누르면 본문이 화면 가득 + [← 목록] (주소 끝 #read — 폰의 뒤로 가기로도 돌아온다).
 *   · 메일함 고르기 칸에도 안 읽은 수 · 수신확인 메일함은 웍스가 목록을 안 준다(개발자 문서) → 안내 문구.
 *
 * 📋 v2.208.0 (2026-09-28 · 사용자 요청 「메일 목록을 기존 웍스모바일에서 보여주는 형식으로 똑같은 형태로 해줘.
 *   지금 포털처럼 내용과 같이 보이는 형태 말고」 — 웍스 웹 메일 「목록만 보기」 캡처)
 *   · 넓은 화면도 3단(목록 300px + 읽기) 대신 **목록이 가득** — 한 통 = 한 줄(안 읽음 · ★ · 📎 · 보낸 사람 · [메일함] 제목 · 날짜).
 *   · 누르면 본문이 그 자리에 가득 + [← 목록] · [▲ 윗 메일]·[▼ 아랫 메일] — 좁은 화면이 쓰던 #read 흐름을 모든 폭이 같이 쓴다.
 *   · 목록으로 돌아오면 보던 자리 그대로(숨겼다 보이면 스크롤이 0 으로 돌아갈 수 있다 → 저장했다 되돌림).
 *   · 찾기 결과의 본문 한 줄·첨부 이름 줄은 없앴다(= 「내용과 같이 보이는」) — 줄에 마우스를 올리면 말풍선으로 보인다.
 *   · 날짜는 웍스처럼 오늘 = 시:분 · 올해 = 「9. 26. 20:20」 · 그 전 = 「2025. 9. 26.」.
 *   · 폰(좁은 화면)은 두 줄 그대로(보낸 사람·날짜 / 제목) — 한 줄로는 제목이 거의 안 보인다.
 *
 * 📎 v2.209.0 (2026-09-28 · 사용자 요청 「첨부파일 이런식으로 보이게」 + 웍스 읽기 화면 캡처)
 *   · 첨부를 알약 단추 줄 대신 **첨부 상자**로 — 머리 「▼ 첨부파일 N개 …… [⬇ 모두 저장]」, 한 줄에 한 파일(종류 딱지·이름·크기·⬇).
 *   · [모두 저장]은 서버가 zip 하나로 묶어 준다(GET /mail/messages/:id/attachments/all) — 화면에서 연달아 받으면
 *     크롬이 「여러 파일 다운로드」를 막을 때 둘째부터 조용히 빠진다.
 *
 * 🖼 v2.210.0 (2026-09-28 · 사용자: 「메일에 로고, 아이콘 등이 외부그림이라고 표시됨」 → 결정 「항상 보이기 · 스팸만 가림」)
 *   · 바깥 그림(http·https — 웍스 서명 로고·아이콘이 바깥 주소다)은 스팸메일함 밖이면 보인다(images=1).
 *   · 스팸메일함 메일은 가린 채 「🛡 … [그림 보기]」 — 누른 메일만 다시 받아 연다.
 */

import { useEffect, useLayoutEffect, useMemo, useRef, useState, type FormEvent, type ReactNode } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useInfiniteQuery, useQuery, useQueryClient, type InfiniteData } from '@tanstack/react-query';
import {
  downloadInboxAttachment,
  downloadInboxAttachmentsZip,
  getMailAccount,
  getMailMessage,
  listMailFolders,
  listMails,
  searchMails,
  searchMailsBySender,
  type MailAddress,
  type MailFolder,
  type MailListPage,
  type MailMessage,
  type MailSearchHit,
  type MailSearchPage,
  type MailSenderScanPage,
  type MailSummary,
  type MailTextPart,
} from '../lib/mail-api';
import { openMailCompose } from '../lib/mail-compose';
import { SegmentedControl } from '../components/ui/SegmentedControl';
import { buildMailSrcdoc, purifyMailHtml } from '../lib/mail-render';
import { ApiCallError } from '../lib/api';
import { LoadingLines } from '../components/ui/Skeleton';

function fmtSize(n: number): string {
  if (n < 1024) return `${n}B`;
  if (n < 1024 * 1024) return `${Math.round(n / 1024)}KB`;
  return `${(n / 1024 / 1024).toFixed(1)}MB`;
}

/** 목록 시각 — 웍스 메일 목록과 같게: 오늘이면 「10:40」, 올해면 「9. 26. 20:20」, 그 전이면 「2025. 9. 26.」 (한국 시각) */
function fmtListTime(iso: string | null): string {
  if (!iso) return '';
  const t = new Date(iso);
  if (Number.isNaN(t.getTime())) return '';
  const kst = (d: Date) => new Date(d.getTime() + 9 * 3600 * 1000);
  const a = kst(t);
  const now = kst(new Date());
  const p = (n: number) => String(n).padStart(2, '0');
  const hm = `${p(a.getUTCHours())}:${p(a.getUTCMinutes())}`;
  if (a.toISOString().slice(0, 10) === now.toISOString().slice(0, 10)) return hm;
  if (a.getUTCFullYear() === now.getUTCFullYear()) return `${a.getUTCMonth() + 1}. ${a.getUTCDate()}. ${hm}`;
  return `${a.getUTCFullYear()}. ${a.getUTCMonth() + 1}. ${a.getUTCDate()}.`;
}

function fmtFullTime(iso: string | null): string {
  if (!iso) return '';
  const t = new Date(iso);
  if (Number.isNaN(t.getTime())) return iso;
  return new Date(t.getTime() + 9 * 3600 * 1000).toISOString().slice(0, 16).replace('T', ' ');
}

const addrLabel = (a: MailAddress | null | undefined): string => (a ? (a.name ? `${a.name} <${a.email}>` : a.email) : '');

/** 제목 앞머리 — 이미 붙어 있으면 또 붙이지 않는다 */
function withPrefix(prefix: 'RE' | 'FW', subject: string): string {
  const re = prefix === 'RE' ? /^\s*(re|회신|답장)\s*:/i : /^\s*(fw|fwd|전달)\s*:/i;
  return re.test(subject) ? subject : `${prefix}: ${subject}`;
}

function uniqEmails(list: string[], exclude: string[]): string[] {
  const ex = new Set(exclude.map((e) => e.toLowerCase()));
  const seen = new Set<string>();
  const out: string[] = [];
  for (const e of list) {
    const k = e.trim().toLowerCase();
    if (!k || ex.has(k) || seen.has(k)) continue;
    seen.add(k);
    out.push(e.trim());
  }
  return out;
}

function errMessage(e: unknown): { text: string; reconnect: boolean } {
  if (e instanceof ApiCallError) {
    const code = (e.details as { code?: string } | undefined)?.code;
    if (code === 'not_connected' || code === 'expired') {
      return { text: '메일 연결이 끊겼습니다. 마이페이지에서 다시 연결해 주세요.', reconnect: true };
    }
    if (e.code === 'UPSTREAM_ERROR') return { text: `네이버웍스가 응답하지 않습니다 — 잠시 뒤 다시 시도해 주세요. (${e.message})`, reconnect: false };
    return { text: e.message, reconnect: false };
  }
  return { text: (e as Error)?.message ?? String(e), reconnect: false };
}

export function MailPage() {
  const account = useQuery({ queryKey: ['mail', 'account'], queryFn: getMailAccount });
  const a = account.data;
  const ready = !!a?.configured && !!a?.connected && a?.status !== 'EXPIRED';

  return (
    <div className="p-3 md:p-6 h-full flex flex-col min-h-0">
      {/* 좁은 화면은 왼쪽 위에 메뉴(☰) 단추가 떠 있다 — 제목이 비켜 서는 것은 index.css 공용 규칙(main h1)이 한다 (v2.232.0) */}
      <div className="flex items-center justify-between gap-3 mb-3 flex-wrap">
        <h1 className="ui-page-title">메일</h1>
        <div className="flex items-center gap-3">
          {a?.nwEmail && <span className="hidden sm:inline text-xs text-slate-500">{a.nwEmail}</span>}
          <button
            type="button"
            onClick={() => openMailCompose({})}
            className="btn btn-primary"
          >
            ✉ 새 메일
          </button>
        </div>
      </div>

      {account.isLoading && <div className="text-sm text-slate-400 py-10 text-center"><LoadingLines /></div>}
      {account.isError && (
        <div className="text-sm text-rose-600 py-10 text-center">{errMessage(account.error).text}</div>
      )}
      {a && !ready && (
        <div className="max-w-xl mx-auto mt-10 px-4 py-4 bg-amber-50 border border-amber-200 text-amber-800 rounded text-sm leading-relaxed">
          {!a.configured ? (
            <>네이버웍스 메일 앱이 아직 등록되지 않았습니다. 관리자에게 문의해 주세요.</>
          ) : a.status === 'EXPIRED' ? (
            <>메일 연결이 만료됐습니다. <a href="/mypage" className="underline font-medium">마이페이지</a>에서 다시 연결하면 받은 메일을 볼 수 있습니다.</>
          ) : (
            <>
              메일 계정이 아직 연결돼 있지 않습니다. <a href="/mypage" className="underline font-medium">마이페이지</a>에서
              본인 웍스 계정을 연결하면 여기서 받은 메일을 보고 답장할 수 있습니다.
            </>
          )}
        </div>
      )}
      {a && ready && <Inbox me={a.nwEmail} />}
    </div>
  );
}

/** 찾은 글자 강조 — 서버가 준 조각을 **글자로만** 그린다 (⛔dangerouslySetInnerHTML 금지 · 보낸 사람이 정한 글자다) */
function Highlight({ parts }: { parts: MailTextPart[] }) {
  return (
    <>
      {parts.map((p, i) => (p.hit
        ? <mark key={i} className="bg-yellow-200 text-inherit rounded-sm px-px">{p.t}</mark>
        : <span key={i}>{p.t}</span>))}
    </>
  );
}


const plainOf = (parts: MailTextPart[]): string => parts.map((p) => p.t).join('');

/**
 * 목록 한 줄 — 메일함 목록 · 찾기 결과가 같이 쓴다 (v2.208.0 웍스 목록 모양)
 *   넓은 화면(lg): 한 줄 = [안 읽음][★][📎][보낸 사람 10rem][[메일함] 제목 ……][날짜]
 *   좁은 화면   : 두 줄 = [보낸 사람 …… 날짜] / [📎 [메일함] 제목]
 * ⭐칸마다 한 번만 그리고 grid 자리만 폭에 따라 바꾼다 — 같은 글자를 두 벌 그리면(하나는 숨김) 찾기·검사가 두 번 센다.
 */
function MailRow({ m, on, sent, onOpen, chip, subject, hint }: {
  m: MailSummary;
  on: boolean;
  /** 보낸메일함처럼 「받는 사람」을 보일 줄 */
  sent: boolean;
  onOpen: () => void;
  /** 어느 메일함에 있는 메일인지 — 제목 앞 [받은메일함] (웍스 「전체메일」과 같게) */
  chip?: string;
  /** 강조된 제목(찾기) — 없으면 그냥 제목 */
  subject?: ReactNode;
  /** 마우스를 올리면 뜨는 말풍선 — 찾기의 본문 한 줄 · 첨부 이름 */
  hint?: string;
}) {
  const who = sent
    ? (m.to[0] ? (m.to[0].name || m.to[0].email) + (m.to.length > 1 ? ` 외 ${m.to.length - 1}` : '') : '')
    : (m.from?.name || m.from?.email || '');
  const clip = m.attachCount > 0;
  return (
    <button
      type="button"
      onClick={onOpen}
      data-mail-id={m.mailId}
      title={hint}
      className={`w-full text-left px-3 py-2 lg:py-1.5 border-b border-slate-100 grid items-center gap-x-2
        grid-cols-[minmax(0,1fr)_auto] lg:grid-cols-[0.375rem_0.875rem_1rem_10rem_minmax(0,1fr)_6.5rem]
        ${on ? 'bg-blue-50' : 'hover:bg-slate-50'}`}
    >
      {/* 넓은 화면 앞 세 칸 — 안 읽음 · 중요 · 첨부 (좁은 화면은 보낸 사람·제목 안에 붙는다) */}
      <span className="hidden lg:block lg:col-start-1 lg:row-start-1">
        {m.unread && <span className="block w-1.5 h-1.5 rounded-full bg-blue-600" aria-label="안 읽음" />}
      </span>
      <span className="hidden lg:block lg:col-start-2 lg:row-start-1 text-xs text-amber-400 leading-none">
        {m.isImportant && <span title="중요">★</span>}
      </span>
      <span className="hidden lg:block lg:col-start-3 lg:row-start-1 text-xs leading-none">
        {clip && <span title={`첨부 ${m.attachCount}개`}>📎</span>}
      </span>
      <span className={`col-start-1 row-start-1 lg:col-start-4 min-w-0 flex items-center gap-2 text-sm ${m.unread ? 'font-bold text-slate-900' : 'text-slate-700'}`}>
        {m.unread && <span className="lg:hidden w-1.5 h-1.5 rounded-full bg-blue-600 shrink-0" aria-label="안 읽음" />}
        <span className="truncate">{who || '(알 수 없음)'}</span>
      </span>
      <span className={`col-start-1 col-span-2 row-start-2 mt-0.5 text-xs lg:col-start-5 lg:col-span-1 lg:row-start-1 lg:mt-0 lg:text-sm truncate ${
        m.unread ? 'font-semibold text-slate-800 lg:text-slate-900' : 'text-slate-500 lg:text-slate-700'
      }`}>
        {clip && <span className="lg:hidden">📎 </span>}
        {chip && <span className="text-slate-400 font-normal">[{chip}] </span>}
        {subject ?? (m.subject || '(제목 없음)')}
      </span>
      <span className="col-start-2 row-start-1 lg:col-start-6 text-right text-xs lg:text-xs text-slate-500 tabular-nums whitespace-nowrap">
        {fmtListTime(m.receivedTime ?? m.sentTime)}
      </span>
    </button>
  );
}

type SearchMode = 'content' | 'from';
interface ActiveSearch {
  mode: SearchMode;
  q: string;
  scope: 'all' | 'folder';
  /** 찾기를 누른 때의 메일함 — 「이 메일함」·「보낸 사람」이 쓴다 */
  folderId: number;
  folderName: string;
  years: 1 | 5;
  /** 보낸메일함이면 받는 사람으로 찾는다 */
  by: 'from' | 'to';
}
/** 목록·찾기 결과 쪽의 공통 모양 — 읽음으로 바꿀 때 세 캐시를 같은 식으로 고친다 */
type AnyMailPage = { mails: MailSummary[] };

function Inbox({ me }: { me: string | null }) {
  const qc = useQueryClient();
  const location = useLocation();
  const navigate = useNavigate();
  const foldersQ = useQuery({ queryKey: ['mail', 'folders'], queryFn: listMailFolders });
  const folders = useMemo<MailFolder[]>(() => {
    const list = foldersQ.data?.folders ?? [];
    // 시스템 메일함(받은·보낸·…) 먼저, 그다음 사용자 메일함 — 웍스가 준 순서를 그 안에서 지킨다
    return [...list.filter((f) => f.folderType === 'S'), ...list.filter((f) => f.folderType !== 'S')];
  }, [foldersQ.data]);
  const [folderId, setFolderId] = useState<number | null>(null);
  useEffect(() => {
    if (folderId !== null || folders.length === 0) return;
    setFolderId(folders.find((f) => f.folderId === 0)?.folderId ?? folders[0]!.folderId);
  }, [folders, folderId]);
  const folder = folders.find((f) => f.folderId === folderId) ?? null;
  // 보낸메일함은 목록에 「받는 사람」을 보인다
  const isSentBox = folderId === 1 || /보낸/.test(folder?.folderName ?? '');
  // ⚠수신확인 메일함은 웍스가 목록을 주지 않는다(개발자 문서 「수신확인 메일함은 조회할 수 없다」) — 부르지 않고 안내한다
  const noList = !!folder && folder.folderType === 'S' && /수신\s*확인/.test(folder.folderName);
  const folderNameOf = (id: number | null): string => (id === null ? '' : folders.find((f) => f.folderId === id)?.folderName ?? '');

  const listQ = useInfiniteQuery({
    queryKey: ['mail', 'list', folderId] as const,
    queryFn: ({ pageParam }) => listMails(folderId!, pageParam),
    initialPageParam: null as string | null,
    getNextPageParam: (last: MailListPage) => last.nextCursor,
    enabled: folderId !== null && !noList,
  });
  const mails = listQ.data?.pages.flatMap((p) => p.mails) ?? [];
  const firstPage = listQ.data?.pages[0];

  /* ── 🔍 찾기 ── */
  const [mode, setMode] = useState<SearchMode>('content');
  const [scope, setScope] = useState<'all' | 'folder'>('all'); // 사용자 결정 09-26 「기본 전체 메일함」
  const [input, setInput] = useState('');
  const [active, setActive] = useState<ActiveSearch | null>(null);
  const contentQ = useInfiniteQuery({
    queryKey: ['mail', 'search', active?.q ?? '', active?.scope === 'all' ? -1 : (active?.folderId ?? -1), active?.years ?? 1],
    queryFn: ({ pageParam }) => searchMails({
      q: active!.q, folderId: active!.scope === 'all' ? -1 : active!.folderId, years: active!.years, cursor: pageParam,
    }),
    initialPageParam: null as string | null,
    getNextPageParam: (last: MailSearchPage) => last.nextCursor,
    enabled: active?.mode === 'content',
    staleTime: 60_000,
  });
  const fromQ = useInfiniteQuery({
    queryKey: ['mail', 'search-from', active?.folderId ?? -1, active?.q ?? '', active?.by ?? 'from'],
    queryFn: ({ pageParam }) => searchMailsBySender(active!.folderId, { q: active!.q, by: active!.by, cursor: pageParam }),
    initialPageParam: null as string | null,
    getNextPageParam: (last: MailSenderScanPage) => last.nextCursor,
    enabled: active?.mode === 'from',
    staleTime: 60_000,
    // ⚠웍스를 여러 번 부르는 찾기다 — 창을 다시 볼 때마다 저절로 다시 훑지 않게
    refetchOnWindowFocus: false,
  });

  const [selected, setSelected] = useState<MailSummary | null>(null);
  // 메일함을 바꾸면 고른 메일과 찾기를 비운다 (찾을 글자는 남겨 두어 다시 누르기 쉽게)
  useEffect(() => { setSelected(null); setActive(null); }, [folderId]);
  // 목록이 없는 메일함(수신확인)에서는 「보낸 사람」 찾기를 쓸 수 없다
  useEffect(() => { if (noList && mode === 'from') setMode('content'); }, [noList, mode]);

  /* ── 본문을 열면 목록 자리에 가득 — 주소 끝에 #read 를 붙인다(뒤로 가기로 목록에 돌아오게) ──
   *   v2.208.0 부터 넓은 화면도 같다(웍스 「목록만 보기」). 전에는 좁은 화면만 이렇게 했다. */
  const pushedRead = useRef(false);
  const reading = location.hash === '#read' && selected !== null;
  useEffect(() => { if (location.hash !== '#read') pushedRead.current = false; }, [location.hash]);
  // 목록으로 돌아오면 보던 자리 그대로 — 숨겼다가 다시 보이면 스크롤이 맨 위로 갈 수 있어 저장해 둔다
  const listScrollRef = useRef<HTMLDivElement>(null);
  const savedScroll = useRef(0);
  const openMail = (m: MailSummary): void => {
    if (!reading && listScrollRef.current) savedScroll.current = listScrollRef.current.scrollTop;
    setSelected(m);
    if (location.hash !== '#read') {
      pushedRead.current = true;
      navigate({ hash: '#read' });
    }
  };
  const backToList = (): void => {
    if (pushedRead.current) {
      pushedRead.current = false;
      navigate(-1);
    } else {
      navigate({ hash: '' }, { replace: true });
    }
  };
  useLayoutEffect(() => {
    if (reading) return;
    const box = listScrollRef.current;
    if (!box) return;
    box.scrollTop = savedScroll.current;
    // [▲][▼]로 옮겨 다녔으면 마지막에 본 메일이 화면 안에 오게
    if (selected) box.querySelector<HTMLElement>(`[data-mail-id="${selected.mailId}"]`)?.scrollIntoView({ block: 'nearest' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reading]);
  // 읽는 중에 왼쪽 메일함을 누르면 목록으로 돌아간다 (주소 끝 #read 도 걷는다)
  const pickFolder = (id: number): void => {
    savedScroll.current = 0;
    if (location.hash === '#read') backToList();
    setFolderId(id);
  };

  // 🖼 바깥 그림(서명 로고·아이콘 등) — 스팸메일함 밖이면 보인다 (v2.210.0 · 사용자 결정 「항상 보이기 · 스팸만 가림」)
  //   스팸메일함 메일은 가린 채로 두고 [그림 보기]를 누른 메일만 연다(열어 본 사실이 보낸 쪽에 알려질 수 있어서)
  const isSpamFolder = (id: number | null | undefined): boolean => {
    const f = folders.find((x) => x.folderId === id);
    return !!f && f.folderType === 'S' && /스팸|spam|junk/i.test(f.folderName);
  };
  const [imagesOn, setImagesOn] = useState<ReadonlySet<number>>(new Set());
  const wantImages = !!selected && (!isSpamFolder(selected.folderId ?? folderId) || imagesOn.has(selected.mailId));

  const msgQ = useQuery({
    queryKey: ['mail', 'message', selected?.mailId, wantImages],
    // 목록에서 「안 읽음」이던 메일을 열 때만 서버가 웍스에 읽음 표시를 보낸다
    queryFn: () => getMailMessage(selected!.mailId, selected!.unread, wantImages),
    enabled: !!selected,
    staleTime: 5 * 60_000,
  });

  // 열었으면 목록·찾기 결과의 굵은 글씨를 풀고 메일함의 안 읽은 수를 다시 받는다
  useEffect(() => {
    if (!msgQ.isSuccess || !selected?.unread) return;
    const id = selected.mailId;
    const upd = (old: InfiniteData<AnyMailPage, string | null> | undefined) =>
      old
        ? { ...old, pages: old.pages.map((p) => ({ ...p, mails: p.mails.map((m) => (m.mailId === id ? { ...m, unread: false } : m)) })) }
        : old;
    for (const k of ['list', 'search', 'search-from']) {
      qc.setQueriesData<InfiniteData<AnyMailPage, string | null>>({ queryKey: ['mail', k] }, upd);
    }
    setSelected({ ...selected, unread: false });
    void qc.invalidateQueries({ queryKey: ['mail', 'folders'] });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [msgQ.isSuccess]);

  const refresh = (): void => {
    void qc.invalidateQueries({ queryKey: ['mail', 'folders'] });
    void qc.invalidateQueries({ queryKey: ['mail', 'list', folderId] });
    if (active) void qc.invalidateQueries({ queryKey: ['mail', active.mode === 'content' ? 'search' : 'search-from'] });
  };

  const startSearch = (next: Partial<Pick<ActiveSearch, 'mode' | 'scope' | 'years'>> = {}): void => {
    const q = input.trim();
    if (!q || folderId === null) return;
    setActive({
      mode: next.mode ?? mode,
      q,
      scope: next.scope ?? scope,
      folderId,
      folderName: folder?.folderName ?? '',
      years: next.years ?? 1,
      by: isSentBox ? 'to' : 'from',
    });
  };
  const submit = (e: FormEvent): void => {
    e.preventDefault();
    startSearch();
  };
  // 찾는 중에 고르기를 바꾸면 그 자리에서 다시 찾는다 (찾기 전이면 다음 찾기에 쓰인다)
  const pickMode = (m: SearchMode): void => { setMode(m); if (active) startSearch({ mode: m }); };
  const pickScope = (s: 'all' | 'folder'): void => { setScope(s); if (active) startSearch({ scope: s }); };

  const listErr = listQ.isError ? errMessage(listQ.error) : foldersQ.isError ? errMessage(foldersQ.error) : null;

  const contentHits: MailSearchHit[] = contentQ.data?.pages.flatMap((p) => p.mails) ?? [];
  const fromPages = fromQ.data?.pages ?? [];
  const fromHits = fromPages.flatMap((p) => p.mails);
  const scannedTotal = fromPages.reduce((n, p) => n + p.scanned, 0);
  const fromDone = fromPages.length > 0 && fromPages[fromPages.length - 1]!.done;
  const folderTotal = fromPages[0]?.totalCount ?? null;

  // [▲ 윗 메일]·[▼ 아랫 메일] — 지금 보이는 목록(메일함 · 찾기 결과) 안에서 옮겨 다닌다 (받아 둔 줄까지만)
  const rows: MailSummary[] = active?.mode === 'content' ? contentHits : active?.mode === 'from' ? fromHits : mails;
  const at = selected ? rows.findIndex((r) => r.mailId === selected.mailId) : -1;
  const prevMail = at > 0 ? rows[at - 1]! : null;
  const nextMail = at >= 0 && at + 1 < rows.length ? rows[at + 1]! : null;

  const more = (label: string, onClick: () => void, busy: boolean): ReactNode => (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      className="btn btn-ghost btn-sm w-full"
    >
      {busy ? '불러오는 중…' : label}
    </button>
  );

  return (
    <div className="flex-1 min-h-0 grid grid-cols-1 grid-rows-[minmax(0,1fr)] lg:grid-cols-[170px_minmax(0,1fr)] gap-3">
      {/* 메일함 */}
      <div className="bg-white border border-slate-200 rounded min-h-0 overflow-auto hidden lg:block">
        <div className="flex items-center justify-between px-3 py-2 border-b border-slate-100">
          <span className="text-xs font-semibold text-slate-600">메일함</span>
          <button type="button" onClick={refresh} title="새로 받기" className="text-slate-400 hover:text-slate-700 text-sm">↻</button>
        </div>
        {foldersQ.isLoading && <div className="text-xs text-slate-500 p-3"><LoadingLines /></div>}
        <ul className="py-1">
          {folders.map((f) => (
            <li key={f.folderId}>
              <button
                type="button"
                onClick={() => pickFolder(f.folderId)}
                className={`w-full flex items-center gap-1.5 px-3 py-1.5 text-sm text-left ${
                  f.folderId === folderId ? 'bg-blue-50 text-blue-800 font-semibold' : 'text-slate-700 hover:bg-slate-50'
                }`}
                style={{ paddingLeft: 12 + Math.max(0, f.folderDepth - 1) * 12 }}
              >
                <span className="shrink-0">{f.folderType === 'S' ? (f.folderId === 0 ? '📥' : f.folderId === 1 ? '📤' : '🗂') : '📁'}</span>
                <span className="truncate">{f.folderName}</span>
                {f.unreadMailCount > 0 && (
                  <span className="ml-auto shrink-0 text-[11px] px-1.5 rounded-full bg-blue-600 text-white">
                    {f.unreadMailCount > 999 ? '999+' : f.unreadMailCount}
                  </span>
                )}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* 목록 — 본문을 읽는 동안은 숨는다 (v2.208.0 부터 넓은 화면도 — 본문이 이 자리에 가득) */}
      <div className={`${reading ? 'hidden' : 'flex'} bg-white border border-slate-200 rounded min-h-0 flex-col`}>
        <div className="flex items-center gap-2 px-3 py-2 border-b border-slate-100">
          {/* 좁은 화면에서는 메일함 칸 대신 고르기 — 안 읽은 수도 같이 (TSP 처럼 「휴지통 (1,499)」) */}
          <select
            className="ui-input ui-input-sm lg:hidden max-w-[60%]"
            value={folderId ?? ''}
            onChange={(e) => pickFolder(Number(e.target.value))}
            aria-label="메일함"
          >
            {folders.map((f) => (
              <option key={f.folderId} value={f.folderId}>
                {f.folderName}{f.unreadMailCount > 0 ? ` (${f.unreadMailCount.toLocaleString()})` : ''}
              </option>
            ))}
          </select>
          <span className="hidden lg:inline text-sm font-semibold text-slate-800 truncate">{folder?.folderName ?? ''}</span>
          <span className="text-xs text-slate-500 shrink-0">
            {firstPage && !noList ? `${firstPage.totalCount.toLocaleString()}건 · 안 읽음 ${firstPage.unreadCount.toLocaleString()}` : ''}
          </span>
          <button type="button" onClick={refresh} title="새로 받기" className="ml-auto lg:hidden text-slate-400 hover:text-slate-700 text-sm">↻</button>
        </div>

        {/* 🔍 찾기 */}
        {/* 넓은 화면은 찾기 칸과 고르기 단추를 한 줄에 (목록이 가득 넓어져서) */}
        <form onSubmit={submit} role="search" className="px-3 py-2 border-b border-slate-100 space-y-1.5 lg:space-y-0 lg:flex lg:items-center lg:gap-3">
          <div className="flex items-center gap-1.5 lg:w-[26rem]">
            <input
              type="search"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              maxLength={100}
              aria-label="메일 찾기"
              placeholder={mode === 'content' ? '제목·본문·첨부 검색' : isSentBox ? '받는 사람 이름·주소' : '보낸 사람 이름·주소'}
              className="ui-input ui-input-sm flex-1 min-w-0"
            />
            <button
              type="submit"
              disabled={!input.trim() || folderId === null}
              className="btn btn-dark btn-sm shrink-0"
            >
              찾기
            </button>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <SegmentedControl ariaLabel="찾을 곳" value={mode} onChange={pickMode}
              options={[
                { key: 'content', label: '내용', title: '제목·본문·첨부 파일에서 찾습니다 (네이버웍스 검색)' },
                {
                  key: 'from', label: isSentBox ? '받는 사람' : '보낸 사람', disabled: noList,
                  title: noList ? '이 메일함은 목록을 받을 수 없어 쓸 수 없습니다' : `이 메일함을 최근 메일부터 1,000건씩 훑어 ${isSentBox ? '받는' : '보낸'} 사람으로 찾습니다`,
                },
              ]} />
            {mode === 'content' && (
              <SegmentedControl ariaLabel="찾을 범위" value={scope} onChange={pickScope}
                options={[{ key: 'all', label: '전체 메일함' }, { key: 'folder', label: '이 메일함' }]} />
            )}
          </div>
        </form>

        <div ref={listScrollRef} className="flex-1 min-h-0 overflow-auto">
          {active?.mode === 'content' ? (
            <>
              <div className="flex items-start gap-2 px-3 py-1.5 bg-amber-50 border-b border-amber-100 text-xs text-amber-900">
                <span className="flex-1 min-w-0">
                  🔍 「{active.q}」 · {active.scope === 'all' ? '전체 메일함' : active.folderName} ·{' '}
                  {active.years === 5 ? `${contentQ.data?.pages[0]?.range.since ?? '5년 전'}부터` : '최근 1년'}
                  {contentQ.isSuccess && <> — <b>{contentHits.length.toLocaleString()}건{contentQ.hasNextPage ? ' 이상' : ''}</b></>}
                </span>
                <button type="button" onClick={() => setActive(null)} title="찾기를 끝내고 메일함 목록으로" className="shrink-0 text-amber-800 hover:text-amber-950">✕ 닫기</button>
              </div>
              {contentQ.isLoading && <div className="text-xs text-slate-500 p-3">찾는 중…</div>}
              {contentQ.isError && <div className="text-xs text-rose-600 p-3">{errMessage(contentQ.error).text}</div>}
              {contentQ.isSuccess && contentHits.length === 0 && (
                <div className="text-xs text-slate-500 p-6 text-center">찾은 메일이 없습니다</div>
              )}
              {contentHits.map((h) => {
                const inSent = h.folderId === 1 || /보낸/.test(folderNameOf(h.folderId));
                // 본문 한 줄 · 첨부 이름은 줄에 안 그리고 말풍선으로 (v2.208.0 「내용과 같이 보이는 형태 말고」)
                const hint = [
                  h.snippetParts.length > 0 ? `본문: ${plainOf(h.snippetParts)}` : '',
                  h.attachHits.length > 0 ? `첨부: ${h.attachHits.map(plainOf).join(' · ')}` : '',
                ].filter(Boolean).join('\n');
                return (
                  <MailRow
                    key={`${h.folderId}-${h.mailId}`}
                    m={h}
                    on={selected?.mailId === h.mailId}
                    sent={inSent && h.to.length > 0}
                    onOpen={() => openMail(h)}
                    // ⚠웍스 검색 결과에는 받는 사람이 없다(개발자 문서 칸 목록에 없음 · 09-28 운영에서도 보낸메일함 결과가 전부 「황재상」) →
                    //   보낸메일함 줄은 「이 메일함」으로 찾아도 [보낸메일함]을 붙여 「내가 보낸 메일」임을 보인다(웍스 「전체메일」과 같게)
                    chip={active.scope === 'all' || (inSent && h.to.length === 0) ? folderNameOf(h.folderId) : undefined}
                    subject={h.subjectParts.length > 0 ? <Highlight parts={h.subjectParts} /> : undefined}
                    hint={hint || undefined}
                  />
                );
              })}
              {contentQ.hasNextPage && more('더 보기', () => void contentQ.fetchNextPage(), contentQ.isFetchingNextPage)}
              {contentQ.isSuccess && !contentQ.hasNextPage && (
                <div className="px-3 py-2 text-xs text-slate-500 text-center">
                  {active.years === 1 ? (
                    <>
                      최근 1년 안에서 찾았습니다 ·{' '}
                      <button type="button" onClick={() => setActive({ ...active, years: 5 })} className="text-blue-700 hover:underline">
                        5년까지 넓혀 찾기
                      </button>
                    </>
                  ) : '5년 안에서 찾았습니다'}
                </div>
              )}
            </>
          ) : active?.mode === 'from' ? (
            <>
              <div className="flex items-start gap-2 px-3 py-1.5 bg-amber-50 border-b border-amber-100 text-xs text-amber-900">
                <span className="flex-1 min-w-0">
                  🔍 {active.by === 'to' ? '받는 사람' : '보낸 사람'} 「{active.q}」 · {active.folderName}
                  {fromPages.length > 0 && (
                    <>
                      {' '}— <b>{fromHits.length.toLocaleString()}건</b> · 최근 {scannedTotal.toLocaleString()}건 훑음
                      {fromDone ? ' (끝까지)' : folderTotal !== null ? ` / 전체 ${folderTotal.toLocaleString()}건` : ''}
                    </>
                  )}
                </span>
                <button type="button" onClick={() => setActive(null)} title="찾기를 끝내고 메일함 목록으로" className="shrink-0 text-amber-800 hover:text-amber-950">✕ 닫기</button>
              </div>
              {fromQ.isLoading && <div className="text-xs text-slate-500 p-3">최근 메일부터 1,000건씩 훑는 중…</div>}
              {fromQ.isError && <div className="text-xs text-rose-600 p-3">{errMessage(fromQ.error).text}</div>}
              {fromQ.isSuccess && fromHits.length === 0 && (
                <div className="text-xs text-slate-500 p-6 text-center">
                  {fromDone ? '찾은 메일이 없습니다' : `최근 ${scannedTotal.toLocaleString()}건 안에는 없습니다`}
                </div>
              )}
              {fromHits.map((m) => (
                <MailRow
                  key={m.mailId}
                  m={m}
                  on={selected?.mailId === m.mailId}
                  sent={active.by === 'to'}
                  onOpen={() => openMail(m)}
                />
              ))}
              {fromQ.hasNextPage && more('더 찾기 — 다음 1,000건', () => void fromQ.fetchNextPage(), fromQ.isFetchingNextPage)}
              {fromQ.isSuccess && fromDone && fromHits.length > 0 && (
                <div className="px-3 py-2 text-xs text-slate-500 text-center">메일함 끝까지 찾았습니다</div>
              )}
            </>
          ) : noList ? (
            <div className="text-xs text-slate-500 p-6 text-center leading-relaxed">
              수신확인 메일함은 네이버웍스가 목록을 주지 않습니다.<br />
              보낸 메일을 상대가 읽었는지는 웍스 메일에서 확인해 주세요.
            </div>
          ) : (
            <>
              {listErr && <div className="text-xs text-rose-600 p-3">{listErr.text}</div>}
              {listQ.isLoading && <div className="text-xs text-slate-500 p-3"><LoadingLines /></div>}
              {!listQ.isLoading && !listErr && mails.length === 0 && (
                <div className="text-xs text-slate-500 p-6 text-center">메일이 없습니다</div>
              )}
              {mails.map((m) => (
                <MailRow key={m.mailId} m={m} on={selected?.mailId === m.mailId} sent={isSentBox} onOpen={() => openMail(m)} />
              ))}
              {listQ.hasNextPage && more('더 보기', () => void listQ.fetchNextPage(), listQ.isFetchingNextPage)}
            </>
          )}
        </div>
      </div>

      {/* 읽기 — 메일을 열었을 때만 목록 자리에 가득 (v2.208.0 부터 넓은 화면도) */}
      <div className={`${reading ? 'flex' : 'hidden'} bg-white border border-slate-200 rounded min-h-0 flex-col`}>
        <div className="flex items-center gap-1.5 px-3 py-2 border-b border-slate-100">
          <button type="button" onClick={backToList} className="text-sm text-blue-700 hover:text-blue-900 mr-auto">← 목록</button>
          <button
            type="button"
            onClick={() => prevMail && openMail(prevMail)}
            disabled={!prevMail}
            title="목록에서 바로 위(더 최근) 메일"
            className="btn btn-secondary btn-sm"
          >
            ▲ 윗 메일
          </button>
          <button
            type="button"
            onClick={() => nextMail && openMail(nextMail)}
            disabled={!nextMail}
            title={nextMail ? '목록에서 바로 아래(더 예전) 메일' : '받아 둔 목록의 끝입니다 — 목록에서 [더 보기]를 눌러 주세요'}
            className="btn btn-secondary btn-sm"
          >
            ▼ 아랫 메일
          </button>
        </div>
        {!selected ? (
          <div className="flex-1 flex items-center justify-center text-sm text-slate-400">메일을 선택하세요.</div>
        ) : msgQ.isLoading ? (
          <div className="flex-1 flex items-center justify-center text-sm text-slate-400"><LoadingLines /></div>
        ) : msgQ.isError ? (
          <div className="flex-1 flex items-center justify-center text-sm text-rose-600 px-6 text-center">{errMessage(msgQ.error).text}</div>
        ) : msgQ.data ? (
          <Reader
            msg={msgQ.data}
            me={me}
            external={wantImages}
            onShowImages={() => { const id = selected.mailId; setImagesOn((s) => new Set(s).add(id)); }}
          />
        ) : null}
      </div>
    </div>
  );
}

function Reader({ msg, me, external, onShowImages }: {
  msg: MailMessage;
  me: string | null;
  /** 바깥 그림을 보이게 받은 메일인가 (스팸메일함 밖 · 또는 [그림 보기]를 누름) */
  external: boolean;
  onShowImages: () => void;
}) {
  const m = msg.mail;
  // ⭐화면 정리(DOMPurify)를 한 번 더 거친 뒤 격리 틀에만 그린다 — 3중 방어 ②③
  const srcdoc = useMemo(
    () => buildMailSrcdoc(purifyMailHtml(msg.html, { external }), { external }),
    [msg.html, external],
  );
  const [dlErr, setDlErr] = useState<string | null>(null);
  // 받는 중인 첨부 id — 'all' 은 [모두 저장](zip)
  const [downloading, setDownloading] = useState<number | 'all' | null>(null);

  const fromLabel = addrLabel(m.from);
  const openCompose = (mode: 'reply' | 'replyAll' | 'forward'): void => {
    const myself = me ? [me] : [];
    const replyTarget = (m.replyTo ?? m.from)?.email;
    let to: string[] = [];
    let cc: string[] = [];
    if (mode === 'reply') {
      to = replyTarget ? [replyTarget] : [];
    } else if (mode === 'replyAll') {
      to = uniqEmails([...(replyTarget ? [replyTarget] : []), ...m.to.map((x) => x.email)], myself);
      cc = uniqEmails(m.cc.map((x) => x.email), [...myself, ...to]);
    }
    openMailCompose({
      to,
      cc,
      subject: withPrefix(mode === 'forward' ? 'FW' : 'RE', m.subject),
      quote: {
        mailId: m.mailId,
        mode,
        originalSubject: m.subject,
        originalFrom: fromLabel,
        ...(mode === 'forward' ? { attachments: msg.attachments } : {}),
      },
    });
  };

  const grab = async (attachmentId: number, filename: string): Promise<void> => {
    if (downloading !== null) return;
    setDownloading(attachmentId);
    setDlErr(null);
    try {
      await downloadInboxAttachment(m.mailId, attachmentId, filename);
    } catch (e) {
      setDlErr((e as Error).message);
    } finally {
      setDownloading(null);
    }
  };
  const grabAll = async (): Promise<void> => {
    if (downloading !== null) return;
    setDownloading('all');
    setDlErr(null);
    try {
      await downloadInboxAttachmentsZip(m.mailId, `${m.subject || '메일'} 첨부.zip`);
    } catch (e) {
      setDlErr((e as Error).message);
    } finally {
      setDownloading(null);
    }
  };

  return (
    <>
      <div className="px-4 py-3 border-b border-slate-100 space-y-1.5">
        {/* 좁은 화면(폰)은 단추를 제목 아래로 — 옆에 붙이면 제목이 세 줄로 꺾인다 (640px 이상은 종전 그대로) */}
        <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-3">
          <h2 className="ui-section-title break-words flex-1 min-w-0">{m.subject || '(제목 없음)'}</h2>
          <div className="flex items-center gap-1.5 shrink-0">
            <button type="button" onClick={() => openCompose('reply')} className="btn btn-secondary btn-sm">↩ 답장</button>
            <button type="button" onClick={() => openCompose('replyAll')} className="btn btn-secondary btn-sm">↩ 전체 답장</button>
            <button type="button" onClick={() => openCompose('forward')} className="btn btn-secondary btn-sm">↪ 전달</button>
          </div>
        </div>
        <div className="text-xs text-slate-600 grid grid-cols-[52px_minmax(0,1fr)] gap-x-2 gap-y-0.5">
          <span className="text-slate-400">보낸 사람</span><span className="break-all">{fromLabel}</span>
          <span className="text-slate-400">받는 사람</span><span className="break-all">{m.to.map(addrLabel).join(', ')}</span>
          {m.cc.length > 0 && (<><span className="text-slate-400">참조</span><span className="break-all">{m.cc.map(addrLabel).join(', ')}</span></>)}
          <span className="text-slate-400">날짜</span><span>{fmtFullTime(m.receivedTime ?? m.sentTime)}</span>
        </div>
        {(msg.attachments.length > 0 || msg.bigFiles.length > 0) && (
          <AttachmentBox msg={msg} downloading={downloading} onGrab={(id, name) => void grab(id, name)} onGrabAll={() => void grabAll()} />
        )}
        {dlErr && <div className="text-xs text-rose-600">{dlErr}</div>}
        {(msg.images.blocked > 0 || msg.images.omitted > 0) && (
          <div className="text-xs text-slate-500">
            {msg.images.blocked > 0 && (
              <>
                🛡 스팸메일함이라 바깥 그림 {msg.images.blocked}개를 가렸습니다(열어 본 사실이 보낸 쪽에 알려지지 않게){' '}
                <button type="button" onClick={onShowImages} className="text-blue-700 hover:underline">그림 보기</button>.{' '}
              </>
            )}
            {msg.images.omitted > 0 && <>그림 {msg.images.omitted}개는 크기·형식 때문에 생략했습니다.</>}
          </div>
        )}
      </div>
      {/* ⭐격리 틀 — 스크립트 금지(allow-scripts 없음) · 부모 화면 접근 금지(allow-same-origin 없음) · 링크만 새 창 */}
      <iframe
        title="메일 본문"
        sandbox="allow-popups allow-popups-to-escape-sandbox"
        referrerPolicy="no-referrer"
        srcDoc={srcdoc}
        className="flex-1 min-h-[320px] w-full border-0 rounded-b"
      />
    </>
  );
}

/** 파일 종류 딱지 — 웍스 첨부 목록의 색 아이콘 자리 (확장자만 본다 · 보낸 사람이 정한 이름이라 글자로만 그린다) */
function fileKind(name: string): { label: string; cls: string } {
  const ext = (/\.([a-z0-9]{1,5})$/i.exec(name)?.[1] ?? '').toLowerCase();
  if (ext === 'pdf') return { label: 'PDF', cls: 'bg-red-500' };
  if (ext === 'hwp' || ext === 'hwpx') return { label: 'HWP', cls: 'bg-sky-500' };
  if (['xls', 'xlsx', 'xlsm', 'csv'].includes(ext)) return { label: 'XLS', cls: 'bg-green-600' };
  if (ext === 'doc' || ext === 'docx') return { label: 'DOC', cls: 'bg-blue-600' };
  if (ext === 'ppt' || ext === 'pptx') return { label: 'PPT', cls: 'bg-orange-500' };
  if (['zip', '7z', 'rar', 'egg', 'alz'].includes(ext)) return { label: 'ZIP', cls: 'bg-amber-600' };
  if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'tif', 'tiff'].includes(ext)) return { label: 'IMG', cls: 'bg-violet-500' };
  return { label: ext ? ext.slice(0, 4).toUpperCase() : 'FILE', cls: 'bg-slate-400' };
}

/**
 * 📎 첨부 상자 — 웍스 메일 읽기 화면과 같게 (v2.209.0 · 사용자 요청 「첨부파일 이런식으로 보이게」 + 웍스 캡처)
 *   머리: [▾ 첨부파일 N개] ……… [모두 저장] (2개 이상일 때 · 서버가 zip 하나로)
 *     합계 크기는 안 적는다 — 대용량(-1)까지 더하면 [모두 저장]이 받는 양과 달라 헷갈린다(웍스도 안 적는다).
 *   몸:   한 줄 = [종류 딱지] 이름 …… 크기 [⬇] — 줄을 누르면 내려받기 · 5줄 넘으면 상자 안에서 스크롤
 *   대용량(-1)은 받기 단추 없이 「본문의 링크에서 받으세요」.
 */
function AttachmentBox({ msg, downloading, onGrab, onGrabAll }: {
  msg: MailMessage;
  downloading: number | 'all' | null;
  onGrab: (attachmentId: number, filename: string) => void;
  onGrabAll: () => void;
}) {
  const [open, setOpen] = useState(true);
  const count = msg.attachments.length + msg.bigFiles.length;
  const busy = downloading !== null;
  return (
    <div className="mt-2 max-w-2xl border border-slate-200 rounded text-xs">
      <div className={`flex items-center gap-2 px-2 py-1.5 bg-slate-50 rounded-t ${open ? 'border-b border-slate-200' : 'rounded-b'}`}>
        <button
          type="button"
          onClick={() => setOpen(!open)}
          aria-expanded={open}
          title={open ? '첨부 목록 접기' : '첨부 목록 펼치기'}
          className="flex items-center gap-1 text-slate-700 hover:text-slate-900"
        >
          <span className="text-[11px] text-slate-500 w-3">{open ? '▼' : '▶'}</span>
          <span className="font-semibold">첨부파일 <span className="text-blue-700">{count}개</span></span>
        </button>
        {msg.attachments.length >= 2 && (
          <button
            type="button"
            onClick={onGrabAll}
            disabled={busy}
            title="받을 수 있는 첨부를 zip 파일 하나로 묶어 내려받습니다"
            className="btn btn-secondary btn-sm ml-auto"
          >
            {downloading === 'all' ? '묶는 중…' : '⬇ 모두 저장'}
          </button>
        )}
      </div>
      {open && (
        <ul className="max-h-[8.75rem] overflow-auto py-0.5">
          {msg.attachments.map((x) => {
            const k = fileKind(x.filename);
            return (
              <li key={x.attachmentId}>
                <button
                  type="button"
                  onClick={() => onGrab(x.attachmentId, x.filename)}
                  disabled={busy}
                  title={`${x.filename} — 눌러서 내려받기`}
                  className="w-full flex items-center gap-2 px-2 py-1 text-left hover:bg-blue-50 disabled:cursor-wait"
                >
                  <span className={`shrink-0 w-8 text-center text-[11px] leading-4 font-bold text-white rounded-sm ${k.cls}`}>{k.label}</span>
                  <span className="flex-1 min-w-0 truncate text-slate-800">{x.filename}</span>
                  <span className="shrink-0 text-slate-400 tabular-nums">{fmtSize(x.size)}</span>
                  <span className="shrink-0 w-12 text-right text-blue-700">{downloading === x.attachmentId ? '받는 중…' : '⬇'}</span>
                </button>
              </li>
            );
          })}
          {msg.bigFiles.map((b, i) => (
            <li
              key={`big${i}`}
              className="flex items-center gap-2 px-2 py-1"
              title="대용량 첨부는 본문 안의 받기 링크로 받습니다"
            >
              <span className="shrink-0 w-8 text-center text-[11px] leading-4 font-bold text-white rounded-sm bg-amber-500">대용량</span>
              <span className="flex-1 min-w-0 truncate text-slate-800">{b.filename}</span>
              <span className="shrink-0 text-amber-700">
                본문의 링크에서 받으세요{b.expireTime ? ` (~${fmtFullTime(b.expireTime).slice(0, 10)})` : ''}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
